<div class="text-navy-90 font-bold text-base">
  {{ title }}
  @if (isRequired) {
    <span class="asterisk"></span>
  }
</div>

@if (subtitle) {
  <div class="text-navy-70 text-base">{{ subtitle }}</div>
}

<div class="w-full flex gap-3">
  <app-text-field
    class="flex-1"
    [placeholder]="placeholder"
    [formControl]="inputText"
    [errorTexts]="errorText"
    (inputFocusOut)="handleBlur()"
  ></app-text-field>

  @if (!saveOnBlur) {
    <app-new-button
      class="h-10"
      [type]="'secondary'"
      [loading]="submitting$ | async"
      [disabled]="submitDisabled"
      [saveButtonSizeDuringLoading]="true"
      [size]="'responsive'"
      (click)="save()"
    >
      {{ saveButtonText || (buildTranslationKey('save') | translate) }}
    </app-new-button>
  }
</div>
